module.exports = __webpack_public_path__ + "images/application/promo/dmarc-digests@2x-c1162ab9.png";